import {
  Col,
  Form,
  Row
} from "react-bootstrap";
import {
  useState
} from "react";
import { useTranslation } from 'react-i18next';
import { Button, Modal } from "react-bootstrap";

export const ModalMulticlient = (props: any) => {
  const [multiclientQuantity, setMulticlientQuantity] = useState<string>()
  const { t } = useTranslation();
  return (
    <>
      <Modal as={Modal.Dialog}         
        centered show={props.show} 
        onHide={props.close} 
        onShow={() => {setMulticlientQuantity('')}}>
        <Modal.Header>
          <Modal.Title className='h6'>{props.Title}</Modal.Title>
          <Button variant='close' aria-label='Close' onClick={props.close} />
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row className="align-items-center">
              <Col xs="5">
                {t('EQUIPMENT.MULTICLIENT_REFERENCE')}
              </Col>
              <Col xs="3">
                <Form.Group>
                  <Form.Control style={{ display: 'none' }} ></Form.Control>
                  <Form.Floating>
                    <Form.Control
                      name='code_equipment'
                      id='code_equipment'
                      type='text'
                      className='form-control'
                      disabled={true}
                      value={props.Message}/>
                  </Form.Floating>
                </Form.Group>
              </Col>
            </Row>
            <br></br>
            <Row className="align-items-center">
              <Col xs="5">
                {t('EQUIPMENT.MULTICLIENT_QUANTITY_LABEL')}
              </Col>
              <Col xs="3">
                <Form.Group>
                  <Form.Control style={{ display: 'none' }} ></Form.Control>
                  <Form.Floating>
                    <Form.Control
                      name='multiclient_quantity'
                      id='multiclient_quantity'
                      type='text'
                      maxLength={3}
                      placeholder={t(`EQUIPMENT.MULTICLIENT_QUANTITY`)}
                      className='form-control'
                      onChange={(event) => {setMulticlientQuantity(event.target.value)}}
                      value={multiclientQuantity}/>
                    <label htmlFor="multiclient_quantity">{t("EQUIPMENT.MULTICLIENT_QUANTITY")}</label>
                  </Form.Floating>
                </Form.Group>
              </Col>
            </Row>  
          </Form>
        </Modal.Body>
        <Modal.Footer style={{ marginLeft: "auto" }}>
          <Button
            variant='primary'
            style={{ marginLeft: "auto" }}
            className='text-gray ms-auto'
            onClick={() => {setMulticlientQuantity('')}}>
            {t('CLEAR')}
          </Button>
          <Button
            variant='primary'
            style={{ marginLeft: "auto" }}
            className='text-gray ms-auto'
            onClick={() => {props.createMulticlient(multiclientQuantity)}}>
            {t('CREATE')}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
